import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { NavController } from '@ionic/angular/standalone';
import { Device } from '@capacitor/device';

import { environment } from '@app/environment';
import { ApiService, CookiesService, LoggedUserService, MenuService, DataService } from '@app/services';
import { JWTAuthRequest, JwtAuthResponse, LoggedUser } from '@app/models';
import { PhotoFiltersValues, PlanningFiltersValues} from '@app/components';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
    
    constructor(
        private navController: NavController,
        private apiService: ApiService,
        private cookiesService: CookiesService,
        private loggedUserService: LoggedUserService,
        private menuService: MenuService,
        private dataService: DataService
    ) { }
    
    getLocalLoginToken(): string {
        return this.cookiesService.get(environment.COOKIE_LOGIN);
    }
    
    async setLocalLoginToken(token: string) {
        await this.cookiesService.set(environment.COOKIE_LOGIN, token, environment.NB_DAYS_TOKEN_LOGIN);
    }
    
    async deleteLocalLoginToken() {
        await this.cookiesService.delete(environment.COOKIE_LOGIN);
    }

    async signInUser(credential: JWTAuthRequest, rememberMe: boolean): Promise<LoggedUser|null>{
        let loggedUser = null;
        let jwtAuthResponse: JwtAuthResponse = (await this.apiService.post('auth/jwt-auth', credential, null, false))?.data;
        if(jwtAuthResponse?.jwttoken){ 
            await this.resetOnLogout();
            this.loggedUserService.jwtToken = jwtAuthResponse?.jwttoken;
            if(rememberMe){
                await this.setLocalLoginToken(jwtAuthResponse.jwttoken);
            }
            loggedUser = await this.checkTokenUser();            
        }       
        return loggedUser;
    }
    
    async checkTokenUser(redirectLogin: boolean = true): Promise<LoggedUser|null> {
        let check = false;       
        
        let token = this.getLocalLoginToken();
        if(token && token !== ''){
            this.loggedUserService.jwtToken = token;
        }
        
        let json: any = (await this.apiService.get('user/customer-user-profile'))?.data;
        if(json){
            this.loggedUserService.setLoggedUser(json);
            if(!this.dataService.initData){
                await this.dataService.init();
            }
            check = true;
        }
        
        if(!check){
            await this.logout(redirectLogin);
        }
        
        this.menuService.refresh();
        
        return this.loggedUserService.loggedUser;
    }
    
    async resetOnLogout(){
        this.dataService.reset();
        PhotoFiltersValues.DeleteFiltersSaved();
        PlanningFiltersValues.DeleteFiltersSaved();
            
        this.loggedUserService.resetLoggedUser();
        await this.deleteLocalLoginToken();  
    }
    
    async logout(redirectLogin: boolean = true) {        
    
        await this.resetOnLogout();
         
        const info = await Device.getInfo();
        if(info.platform === 'web'){            
            // A MODIFIER - A supprimer une fois le portail de connexion en PROD           
            if(redirectLogin){         
                this.navController.navigateRoot('login', {replaceUrl: true});
            }            
            //location.href = environment.URL_MARVING+'logout';  
        }
        else{
            location.href = '/logout';  
        }
    
    }

    async autoSignInUser(accessToken: String): Promise<LoggedUser | null> {
        let loggedUser = null;
        let jwtAuthResponse: JwtAuthResponse = (await this.apiService.post('auth/autologin', accessToken, null, false))?.data;
        if (jwtAuthResponse?.jwttoken) {
            await this.resetOnLogout();
            this.loggedUserService.jwtToken = jwtAuthResponse?.jwttoken;
            loggedUser = await this.checkTokenUser();            
        }        
        return loggedUser;
    }
}
